"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var queryString_1 = require("../helpers/queryString");
var CrmTasksModel = /** @class */ (function () {
    function CrmTasksModel($http, APPURL) {
        this.$http = $http;
        this.APPURL = APPURL;
        this.URLS = {
            FETCH: APPURL + "/api/v1/crm/tasks",
            UPDATE: APPURL + "/api/v1/crm/tasks",
            CREATE: APPURL + "/api/v1/crm/tasks",
        };
        this.data = [];
        this.extract = this.extract.bind(this);
        this.cacheResults = this.cacheResults.bind(this);
    }
    CrmTasksModel.prototype.extract = function (result) {
        return result.data;
    };
    CrmTasksModel.prototype.cacheResults = function (result) {
        this.data = this.extract(result);
        return this.data;
    };
    CrmTasksModel.prototype.getTaskByID = function (id) {
        return this.$http
            .get(this.URLS.FETCH + "/" + id)
            .then(this.cacheResults);
    };
    CrmTasksModel.prototype.get = function (data) {
        if (data === void 0) { data = null; }
        if (data !== null) {
            return this.$http
                .get(this.URLS.FETCH + "?" + (0, queryString_1.toQueryString)(data))
                .then(this.cacheResults);
        }
        return this.$http
            .get(this.URLS.FETCH)
            .then(this.cacheResults);
    };
    CrmTasksModel.prototype.update = function (request) {
        return this.$http
            .put(this.URLS.FETCH + "/" + request.id, request)
            .then(this.cacheResults);
    };
    CrmTasksModel.prototype.create = function (request) {
        return this.$http
            .post(this.URLS.FETCH, request)
            .then(this.cacheResults);
    };
    CrmTasksModel.prototype.destroy = function (task) {
        return this.$http
            .delete(this.URLS.FETCH + "/" + task.id)
            .then(this.cacheResults);
    };
    return CrmTasksModel;
}());
CrmTasksModel.$inject = ["$http", "APPURL"];
exports.default = CrmTasksModel;
